module.exports = __webpack_public_path__ + "static/img/bbc.db7def8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/bbc.gif
// module id = MqZI
// module chunks = 51